// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"61":"contactView","187":"albumView","204":"discographyView","369":"homeView","449":"notFound","722":"soonView","818":"aboutView"}[chunkId] + "." + {"61":"a3248eca","187":"370e5c04","204":"ea0c554e","369":"8a5f1283","449":"c42ff527","722":"c86d5a95","818":"191d23b7"}[chunkId] + ".css";
};